import { ExternalAuthenticationProviderType, type PaymentMethodExternalAuthentication } from '@src/domains/payments';
import { BraspagProvider, MalgaProvider, PagarmeProvider } from '@src/features/payments/external-auth/providers';
import { AttemptsManager, AttemptsManagerParams } from './attempts-manager';
import { ExternalAuthenticationProvider, ExternalAuthResult } from './types';

export class ExternalAuthenticationProviderFactory {
  private static providers: Map<ExternalAuthenticationProviderType, ExternalAuthenticationProvider> = new Map<
    ExternalAuthenticationProviderType,
    ExternalAuthenticationProvider
  >([
    [ExternalAuthenticationProviderType.Bpmpi, new BraspagProvider()],
    [ExternalAuthenticationProviderType.Pgmpi, new PagarmeProvider()],
    [ExternalAuthenticationProviderType.Malga3ds2, new MalgaProvider()],
  ]);

  static getProvider(
    paymentMethodExternalAuthentication: PaymentMethodExternalAuthentication,
  ): ExternalAuthenticationProvider {
    const providerType = paymentMethodExternalAuthentication.type;
    const provider = this.providers.get(providerType);

    if (!provider) {
      throw new Error(`Unsupported external authentication provider: ${providerType}`);
    }

    return provider;
  }

  static async handleAuthentication(params: AttemptsManagerParams): Promise<ExternalAuthResult> {
    const { paymentMethodExternalAuthentication } = params;

    const provider = this.getProvider(paymentMethodExternalAuthentication);

    return await AttemptsManager.handleAuthentication(provider, params);
  }
}
